import axios from 'axios'
import * as Types from '../types'

export default
{
	state:
	{
	},

	getters:
	{
	},

	mutations:
	{
	},

	actions:
	{
		[Types.TICKET_CREATE]({ commit }, { data })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.post('/api/tickets', data)
						.then(resolve)
						.catch(reject)
				}
			)
		},
		[Types.TICKET_COMMENT]({ commit }, { data })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.post('/api/tickets/' + data.ticket_number, data)
						.then(resolve)
						.catch(reject)
				}
			)
		},
	},
}